import { BRAND } from "@/content";
import Logo from "@/components/Logo";
import { MapPin, Phone, Mail, Music2 } from "lucide-react";
import { whatsappLink, WhatsAppGlyph } from "@/components/WhatsApp";

export default function Footer() {
  return (
    <footer
      data-testid="section-footer"
      className="bg-brand-ink text-brand-cream py-16 lg:py-20 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-brand-olive-deep/25 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="rounded-[2rem] border border-brand-cream/10 bg-brand-cream/[0.035] backdrop-blur-sm p-7 lg:p-10">
          <div className="grid gap-10 text-center lg:grid-cols-12 lg:text-right">
            <div className="lg:col-span-5">
              <div className="flex justify-center lg:justify-start">
                <Logo variant="dark" size="lg" />
              </div>
              <p className="mx-auto mt-6 max-w-md text-base leading-loose text-brand-cream/72 lg:mx-0">
                مُيسر للتطوير العقاري — اسم تثق به في عالم العقار. نلتزم بتقديم
                مشاريع سكنية تجمع بين الجودة، الإتقان، والرفاهية في كل تفصيلة.
              </p>

              <div className="mt-8 flex flex-wrap items-center justify-center gap-3 lg:justify-start">
                <a
                  href={whatsappLink(null, "footer")}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1eb958] text-white px-4 py-2.5 text-base rounded-full transition-colors"
                  data-testid="footer-whatsapp-btn"
                >
                  <WhatsAppGlyph size={16} />
                  واتساب
                </a>
                <a
                  href={BRAND.telUrl}
                  className="inline-flex items-center gap-2 bg-brand-cream/10 hover:bg-brand-cream/16 text-brand-cream px-4 py-2.5 text-base rounded-full border border-brand-cream/12 transition-colors"
                  data-testid="footer-call-btn"
                >
                  <Phone size={14} />
                  اتصل
                </a>
              </div>
            </div>

            <div className="lg:col-span-3">
              <div className="text-base text-brand-accent mb-5">
                المشروع
              </div>
              <ul className="space-y-3 text-base text-brand-cream/75">
                <li><a href="#about" className="hover:text-brand-accent transition-colors" data-testid="footer-link-about">عن المشروع</a></li>
                <li><a href="#location" className="hover:text-brand-accent transition-colors" data-testid="footer-link-location">الموقع</a></li>
                <li><a href="#specs" className="hover:text-brand-accent transition-colors" data-testid="footer-link-specs">المواصفات</a></li>
                <li><a href="#warranties" className="hover:text-brand-accent transition-colors" data-testid="footer-link-warranties">الضمانات</a></li>
                <li><a href="#models" className="hover:text-brand-accent transition-colors" data-testid="footer-link-models">النماذج</a></li>
                <li><a href="#faq" className="hover:text-brand-accent transition-colors" data-testid="footer-link-faq">أسئلة شائعة</a></li>
              </ul>
            </div>

            <div className="lg:col-span-4">
              <div className="text-base text-brand-accent mb-5">
                تواصل
              </div>
              <ul className="space-y-4 text-base">
                <li className="flex items-center justify-center gap-3 lg:justify-start">
                  <Phone size={16} className="text-brand-accent flex-shrink-0" />
                  <a href={BRAND.telUrl} className="text-brand-cream/85 hover:text-brand-accent" dir="ltr" data-testid="footer-phone">
                    {BRAND.phoneDisplay}
                  </a>
                </li>
                <li className="flex items-center justify-center gap-3 lg:justify-start">
                  <Mail size={16} className="text-brand-accent flex-shrink-0" />
                  <a href={`mailto:${BRAND.email}`} className="text-brand-cream/85 hover:text-brand-accent" data-testid="footer-email">
                    {BRAND.email}
                  </a>
                </li>
                <li className="flex items-center justify-center gap-3 lg:justify-start">
                  <Music2 size={16} className="text-brand-accent flex-shrink-0" />
                  <a
                    href={BRAND.tiktokUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand-cream/85 hover:text-brand-accent"
                    data-testid="footer-tiktok"
                  >
                    @{BRAND.tiktok}
                  </a>
                </li>
                <li className="flex items-center justify-center gap-3 lg:justify-start">
                  <MapPin size={16} className="text-brand-accent flex-shrink-0" />
                  <span className="text-brand-cream/85">الدمام — المملكة العربية السعودية</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-4 border-t border-brand-cream/10 pt-8 text-center text-sm text-brand-cream/55 lg:justify-between">
            <span>© {new Date().getFullYear()} {BRAND.companyAr}. جميع الحقوق محفوظة.</span>
            <span>تاون هاوس الشامخة</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
